// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import store from 'store';
import App from './App';
import router from './router';
import _ from './util/util';
import http from './util/http';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import echarts from 'echarts';

import loadImage from './components/loadImage.vue';
Vue.component('loadImage', loadImage);

Vue.use(router);
Vue.use(ElementUI);
//Vue.use(store);

Vue.prototype.$_ = _;
Vue.prototype.$http = http;
Vue.prototype.$store = store;
Vue.prototype.$echarts = echarts;
Vue.prototype.$typeList = ['综合', '师范', '医药', '工科', '艺术', '体育', '财经', '政法', '语言', '农业', '民族', '林业'];
Vue.prototype.$provinceList = [{
    id: 11,
    name: '北京'
  },
  {
    id: 12,
    name: '天津'
  },
  {
    id: 13,
    name: '河北'
  },
  {
    id: 14,
    name: '山西'
  },
  {
    id: 15,
    name: '内蒙古'
  },
  {
    id: 21,
    name: '辽宁'
  },
  {
    id: 22,
    name: '吉林'
  },
  {
    id: 23,
    name: '黑龙江'
  },
  {
    id: 31,
    name: '上海'
  },
  {
    id: 32,
    name: '江苏'
  },
  {
    id: 33,
    name: '浙江'
  },
  {
    id: 34,
    name: '安徽'
  },
  {
    id: 35,
    name: '福建'
  },
  {
    id: 36,
    name: '江西'
  },
  {
    id: 37,
    name: '山东'
  },
  {
    id: 41,
    name: '河南'
  },
  {
    id: 42,
    name: '湖北'
  },
  {
    id: 43,
    name: '湖南'
  },
  {
    id: 44,
    name: '广东'
  },
  {
    id: 45,
    name: '广西'
  },
  {
    id: 46,
    name: '海南'
  },
  {
    id: 50,
    name: '重庆'
  },
  {
    id: 51,
    name: '四川'
  },
  {
    id: 52,
    name: '贵州'
  }, {
    id: 53,
    name: '云南'
  }, {
    id: 54,
    name: '西藏'
  }, {
    id: 61,
    name: '陕西'
  }, {
    id: 62,
    name: '甘肃'
  }, {
    id: 63,
    name: '青海'
  }, {
    id: 64,
    name: '宁夏'
  }, {
    id: 65,
    name: '新疆'
  }, {
    id: 71,
    name: '台湾'
  }, {
    id: 81,
    name: '香港'
  }, {
    id: 82,
    name: '澳门'
  }
];

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js